export function phoneNumbersOnly(){
    if(jQuery('.wpcf7').length > 0 || jQuery('.sales_page').length > 0) {
        jQuery('#contact_phone,#contact_phone_side').keydown(function(e) {
            //console.log(e.which)
            var ctrl = e.ctrlKey ? e.ctrlKey : (((e.keyCode || e.which) === 17) ? true : false);
            
            if(((e.keyCode || e.which) > 95 && (e.keyCode || e.which) < 106) || ((e.keyCode || e.which) == 86 && ctrl)){
                return true;
            }
            else if ((e.keyCode || e.which) > 31 && ((e.keyCode || e.which) != 46 &&((e.keyCode || e.which) < 48 || (e.keyCode || e.which) > 57))){
                e.preventDefault();
                return false;
            }
            else{
                return true;
            }
        })
    }
}
export function fieldOnFocusBlur(){
    
    
    if(jQuery('.wpcf7').length > 0) {
        jQuery('.wpcf7-form-control-wrap .wpcf7-form-control').focus(function(){
            jQuery(this).parents('li').find("label").addClass('focus');
            
            if(jQuery(this).attr('id') === "vin"){
                jQuery(this).attr('placeholder', 'LVXMAXBAXXXXXXXXX');
            }

            if (jQuery(this).attr('id') === "registration") {
                jQuery(this).attr('placeholder', 'aa-123-aa');
            }

            if(jQuery(this).hasClass('wpcf7-not-valid')){
                jQuery(this).parents('li').find(".descr").hide();
            }else{
                jQuery(this).parents('li').find(".descr").show();
            }
            
        })
        jQuery('.wpcf7-form-control-wrap .wpcf7-form-control').blur(function(){
            if (!jQuery(this).val()) {
                jQuery(this).parents('li').find("label").removeClass('focus');
            }

            if (jQuery(this).attr('id') === "vin" || jQuery(this).attr('id') === "registration") {
                jQuery(this).attr('placeholder', '');
            }
            
            if(jQuery(this).parents('li').find(".descr")){
                jQuery(this).parents('li').find(".descr").hide();
            }
        })

        $(".wpcf7-form-control-wrap select.wpcf7-form-control").each(function(){
            $("option:first", this).attr("disabled", "true");
        });

        let wpcf7Elm = document.querySelectorAll('.wpcf7');
        wpcf7Elm[0].addEventListener( 'wpcf7invalid', function( event ) {
            setTimeout(function(){
                jQuery('.wpcf7-form-control-wrap .wpcf7-form-control').each(function(){
                    if(jQuery(this).hasClass('wpcf7-not-valid')){
                        jQuery(this).parents('li').find(".descr").hide();
                    }
                    else{
                        jQuery(this).parents('li').find(".descr").show();
                    }
                });
            },1)
            
        })
    }
}